import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import ChevronRight from '@material-ui/icons/ChevronRight'
import { Link } from 'gatsby'

const useStyles = makeStyles((theme) => ({
  linkButton: {
    color: 'rgba(47, 164, 59, 1)',
    textTransform: 'none',
    textDecoration: 'none',
    fontFamily: 'Poppins, sans-serif',
    fontSize: 12,
    fontWeight: 600,
    borderRadius: 10,
    display: 'flex',
    alignItems: 'center',
    height: 35,

    '&:hover': {
      textDecoration: 'underline',
    },

    [theme.breakpoints.up('desktop')]: {
      fontSize: 14,
    },

    cursor: 'pointer',
  },
  linkButtonWhite: {
    color: 'white',
    textTransform: 'none',
    textDecoration: 'none',
    fontFamily: 'Poppins, sans-serif',
    fontSize: 10,
    fontWeight: 600,
    borderRadius: 10,
    display: 'flex',
    alignItems: 'center',
    height: 35,

    '&:hover': {
      textDecoration: 'underline',
    },

    [theme.breakpoints.up('desktop')]: {
      fontSize: 12,
    },

    cursor: 'pointer',
  },
  chevron: {
    height: 25,
  },
}))
export default function LinkButton({ children, chevronRight, href, white }) {
  const classes = useStyles()
  return (
    <Link
      className={white ? classes.linkButtonWhite : classes.linkButton}
      to={href}
    >
      {children}
      {chevronRight && <ChevronRight className={classes.chevron} />}
    </Link>
  )
}

LinkButton.propTypes = {
  children: PropTypes.node,
  href: PropTypes.string.isRequired,
  chevronRight: PropTypes.bool,
  white: PropTypes.bool,
}

LinkButton.defaultProps = {
  children: '',
  chevronRight: true,
  white: false,
}
